import { createContext, useContext } from 'react'

// Context for additive search providers (e.g. help articles, product navigation).
// These providers run alongside the primary provider and contribute supplementary
// results that are displayed in separate UI slots, not replacing the main results.

const defaultValue = {
  // Array of result blocks, one per registered additive provider.
  // Shape: Array<{ providerId: string, label: string, hits: any[] }>
  additiveResults: [],
}

export const SupplementarySearchContext = createContext(defaultValue)

export function useSupplementarySearch() {
  return useContext(SupplementarySearchContext)
}
